var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBond = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M477.715 34.2914C432.003 -11.4202 357.622 -11.4297 311.904 34.2662L311.913 34.2756L239.581 106.62L272.97 140.002L345.314 67.6417L345.308 67.6354C372.624 40.3665 417.029 40.3822 444.327 67.6795C471.627 94.9768 471.624 139.404 444.327 166.711L335.773 275.258C329.287 281.781 321.571 286.953 313.073 290.473C304.574 293.994 295.461 295.794 286.262 295.768C277.063 295.794 267.95 293.994 259.451 290.473C250.952 286.953 243.235 281.781 236.748 275.258L203.36 308.643C225.505 330.787 254.949 342.985 286.266 342.985C317.583 342.985 347.027 330.787 369.162 308.643L477.718 200.096C523.42 154.375 523.42 79.9935 477.715 34.2914Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.705 444.342C139.398 471.633 94.9739 471.627 67.6735 444.327C40.3731 417.02 40.3731 372.586 67.6703 345.283L176.211 236.742C203.518 209.439 247.945 209.439 275.245 236.742L308.637 203.357C262.919 157.642 188.538 157.639 142.826 203.357L34.279 311.898C-11.4231 357.612 -11.4231 431.997 34.2822 477.715C57.1443 500.574 87.1675 512.003 117.197 512C147.214 512 177.237 500.577 200.087 477.73L200.093 477.727L272.441 405.361L239.049 371.976L166.705 444.342Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBond);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bond.464f35840ccba5e7e5f1cef35cf2de40.svg";